import { Button, Col, Row } from "react-bootstrap";
import "./Homepage.css";
import { motion } from "framer-motion";
import home from "../assets/images/home.png";
import { useNavigate } from "react-router-dom";

function HomePage() {
  const navigate = useNavigate();
  return (
    <>
      <div className="homepage overflow-hidden">
        <div className="">
          {/* <Header /> */}
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <Row
                className="d-flex align-items-center justify-content-between mt-5 gap-sm-0 gap-5"
                style={{ padding: "140px 0px 20px 0px" }}
              >
                <Col lg={6} md={6}>
                  <motion.div
                    initial={{ x: -100 }}
                    animate={{ x: 0 }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                  >
                    <div className="text-center text-md-start">
                      {/* <h2 className="fw-bold text-uppercase mb-3 lh-base">
                        Mobile App Development
                      </h2>
                      <h5>
                        The full set of service around development and
                        maintenance of complex business-critical application.
                      </h5> */}
                      <h2 className="black-text  mb-3 lh-base h2">
                       <span className="black-text">Mobile & Web</span> <br /> Innovation for Scalable <br /> Business Growth</h2>
                        {/* <span>Mobile & Web</span> <br />
                        Development Solution <br /> Company
                      </h2> */}
                      <p style={{fontSize:"16px"}}>
                        {/* Welcome to Flora Infotech, your one-stop destination for innovative Web Development, cutting-edge App Development, 
                        and creative Web Design solutions. We specialize in crafting seamless digital experiences that are not only visually stunning but also highly functional and user-friendly. */}
                        We craft innovative web and mobile applications tailored
                        to your business needs. From startups to enterprises, we
                        deliver scalable and user-centric digital solutions.
                        Let’s build the future of your brand—together.
                      </p>
                      <Button
                        className="mt-3 btn btn-contact"
                        onClick={() => {
                          navigate("/contact");
                        }}
                      >
                        {" "}
                        <span> Get In Touch</span>
                      </Button>
                    </div>
                  </motion.div>
                </Col>
                <Col className="text-center text-lg-end" lg={6} md={6}>
                  <motion.div
                    initial={{ scale: 0.9, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.7 }}
                  >
                    <img
                      className="img"
                      src={home}
                      alt=""
                      style={{ height: "450px" }}
                    />
                  </motion.div>
                </Col>
              </Row>
            </motion.div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HomePage;
